<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 30 40"
    style="enable-background: new 0 0 30 40;"
    xml:space="preserve"
  >
    <g id="oi1Tuj.tif">
      <g>
        <path
          class="st0"
          d="M17,33.6c0.9,0,1.4-0.7,1.3-1.4c-0.3-1.6-0.5-3.3-0.9-4.9c-0.1-0.4,0-0.7,0.3-1c1.2-1.1,2.3-2.2,3.5-3.4
			c0.4-0.4,0.6-0.8,0.4-1.4c-0.2-0.6-0.6-0.8-1.2-0.9c-1.6-0.2-3.2-0.5-4.9-0.7c-0.3,0-0.5-0.2-0.7-0.5c-0.7-1.5-1.5-3-2.2-4.5
			c-0.2-0.5-0.6-0.8-1.1-0.8c-0.6,0-0.9,0.3-1.2,0.8c-0.7,1.5-1.5,3-2.2,4.5c-0.1,0.2-0.3,0.4-0.5,0.4c-1.6,0.2-3.3,0.5-4.9,0.7
			c-0.6,0.1-1,0.3-1.2,0.9c-0.2,0.6,0.1,1,0.5,1.4c1.1,1.1,2.2,2.2,3.4,3.3c0.4,0.3,0.4,0.7,0.3,1.1c-0.3,1.5-0.5,3.1-0.8,4.7
			c-0.1,0.6,0,1,0.5,1.4c0.5,0.3,0.9,0.3,1.4,0c1.5-0.8,2.9-1.6,4.4-2.3c0.2-0.1,0.5-0.1,0.6,0c1.5,0.8,3,1.5,4.4,2.3
			C16.6,33.4,16.9,33.5,17,33.6z M19.2,6.4c-0.2,0.2-0.3,0.4-0.4,0.5c-0.3,0.7-0.5,1.4-0.9,2c-0.1,0.2-0.3,0.5-0.6,0.6
			c-0.7,0.3-1.4,0.6-2.1,0.9c-0.1,0.1-0.3,0.2-0.3,0.3c0,0.1,0.2,0.3,0.3,0.4c0.7,0.3,1.3,0.6,2,0.8c0.3,0.1,0.5,0.3,0.7,0.7
			c0.2,0.7,0.5,1.3,0.8,1.9c0.1,0.2,0.3,0.3,0.4,0.4c0.1-0.1,0.3-0.2,0.4-0.4c0.3-0.7,0.5-1.3,0.8-2c0.1-0.2,0.3-0.5,0.6-0.6
			c0.7-0.3,1.3-0.6,2-0.9c0.1-0.1,0.3-0.2,0.3-0.4c0-0.1-0.2-0.3-0.3-0.4c-0.7-0.3-1.3-0.6-2-0.8c-0.3-0.1-0.5-0.3-0.6-0.7
			c-0.3-0.7-0.5-1.3-0.8-2C19.5,6.8,19.4,6.7,19.2,6.4z M25.2,21.8c0.1-0.2,0.2-0.3,0.3-0.4c0.2-0.5,0.4-1,0.6-1.5
			c0.1-0.2,0.4-0.5,0.6-0.6c0.5-0.3,1-0.4,1.5-0.6c0.1-0.1,0.3-0.2,0.3-0.3c0-0.1-0.2-0.2-0.3-0.3c-0.5-0.2-1.1-0.4-1.6-0.7
			c-0.2-0.1-0.4-0.3-0.5-0.5c-0.3-0.5-0.4-1.1-0.7-1.6c-0.1-0.1-0.2-0.3-0.3-0.3c-0.1,0-0.2,0.2-0.3,0.3c-0.1,0.2-0.2,0.4-0.2,0.6
			c-0.2,1-0.9,1.7-1.9,1.9c-0.2,0-0.4,0.1-0.6,0.3c-0.1,0.1-0.3,0.2-0.3,0.3c0,0.1,0.2,0.3,0.3,0.3c0.5,0.2,1.1,0.4,1.6,0.7
			c0.2,0.1,0.3,0.2,0.4,0.4c0.3,0.5,0.5,1.1,0.7,1.6C24.9,21.5,25,21.6,25.2,21.8z"
        />
        <path
          class="st0"
          d="M17,33.6c-0.1,0-0.4-0.1-0.6-0.2c-1.5-0.8-3-1.6-4.4-2.3c-0.2-0.1-0.5-0.1-0.6,0c-1.5,0.8-3,1.5-4.4,2.3
			c-0.5,0.3-1,0.4-1.4,0C5,33,4.9,32.5,5,31.9c0.3-1.6,0.5-3.1,0.8-4.7c0.1-0.5,0-0.8-0.3-1.1c-1.2-1.1-2.3-2.2-3.4-3.3
			c-0.4-0.4-0.7-0.8-0.5-1.4c0.2-0.6,0.6-0.8,1.2-0.9c1.6-0.2,3.3-0.5,4.9-0.7c0.3,0,0.4-0.2,0.5-0.4c0.7-1.5,1.5-3,2.2-4.5
			c0.2-0.5,0.6-0.8,1.2-0.8c0.6,0,0.9,0.3,1.1,0.8c0.7,1.5,1.5,3,2.2,4.5c0.1,0.3,0.3,0.4,0.7,0.5c1.6,0.2,3.2,0.5,4.9,0.7
			c0.6,0.1,1,0.3,1.2,0.9c0.2,0.6,0,1-0.4,1.4c-1.2,1.1-2.3,2.3-3.5,3.4c-0.3,0.3-0.4,0.6-0.3,1c0.3,1.6,0.6,3.3,0.9,4.9
			C18.5,32.9,17.9,33.6,17,33.6z"
        />
        <path
          class="st0"
          d="M19.2,6.4c0.2,0.2,0.3,0.3,0.4,0.5c0.3,0.7,0.6,1.3,0.8,2c0.1,0.3,0.3,0.5,0.6,0.7c0.7,0.3,1.3,0.5,2,0.8
			c0.1,0.1,0.3,0.2,0.3,0.4c0,0.1-0.2,0.3-0.3,0.4c-0.7,0.3-1.4,0.6-2,0.9c-0.2,0.1-0.5,0.4-0.6,0.6c-0.3,0.6-0.6,1.3-0.8,2
			c-0.1,0.2-0.3,0.3-0.4,0.4c-0.1-0.1-0.3-0.3-0.4-0.4c-0.3-0.6-0.6-1.3-0.8-1.9c-0.1-0.3-0.3-0.5-0.7-0.7c-0.7-0.3-1.3-0.5-2-0.8
			c-0.1-0.1-0.3-0.2-0.3-0.4c0-0.1,0.2-0.3,0.3-0.3c0.7-0.3,1.4-0.6,2.1-0.9C17.7,9.4,17.9,9.2,18,9c0.3-0.7,0.6-1.3,0.9-2
			C18.9,6.8,19.1,6.7,19.2,6.4z"
        />
        <path
          class="st0"
          d="M25.2,21.8c-0.1-0.2-0.3-0.3-0.3-0.4c-0.2-0.5-0.4-1.1-0.7-1.6c-0.1-0.2-0.2-0.3-0.4-0.4
			c-0.5-0.3-1.1-0.5-1.6-0.7c-0.1-0.1-0.3-0.2-0.3-0.3c0-0.1,0.2-0.2,0.3-0.3c0.2-0.1,0.4-0.2,0.6-0.3c1-0.2,1.7-0.9,1.9-1.9
			c0-0.2,0.1-0.4,0.2-0.6c0.1-0.1,0.2-0.3,0.3-0.3c0.1,0,0.2,0.2,0.3,0.3c0.2,0.5,0.4,1.1,0.7,1.6c0.1,0.2,0.3,0.4,0.5,0.5
			c0.5,0.3,1.1,0.4,1.6,0.7c0.1,0.1,0.3,0.2,0.3,0.3c0,0.1-0.2,0.3-0.3,0.3c-0.5,0.2-1,0.4-1.5,0.6c-0.2,0.1-0.5,0.3-0.6,0.6
			c-0.3,0.5-0.4,1-0.6,1.5C25.4,21.5,25.3,21.6,25.2,21.8z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
